import React from 'react';
import { Icon } from 'anf-core-react';
import TmntHtml from '../../tools/TmntHtml';
import { replacePlaceholders } from '../../tools/tmntHelpers';

export default function ExchangesQuickviewError({ tmntData, helpPageLink }) {
  const contactHelpLink = replacePlaceholders(tmntData.exchangeNoLongerAvailableContactHelp?.value, { 0: helpPageLink });

  return (
    <div className="exchanges-quickview-error" data-testid="exchanges-quickview-error">
      <Icon icon="exclamation" size="s" />
      <div className="exchanges-no-longer-available-message" data-type-style="body">
        {tmntData?.exchangeNoLongerAvailable?.value}
      </div>

      <div className="exchange-no-longer-available-contact-help">
        <TmntHtml value={contactHelpLink} />
      </div>
    </div>
  );
}
